module.exports = __webpack_public_path__ + "img/iso-image.0a97170c.jpeg";